import { useMemo, useRef } from 'react';
import { EnhancedAutocomplete } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCreateLegalTerms } from "./hooks/useCreateLegalTerms";
import { useLegalTerms } from "./hooks/useLegalTerms";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const GetLegalTermsDropdownTID = testid => getTestIds(testid);
export const LegalTermsDropdown = _ref => {
  let {
    selectedLegalTermId,
    onSelectLegalTerm,
    testid,
    disabled,
    entityLegalTerms
  } = _ref;
  const {
    LegalTermsDropdownTID
  } = useMemo(() => GetLegalTermsDropdownTID(testid), [testid]);
  const {
    legalTerms,
    isLoading: isLoadingLegalTerms
  } = useLegalTerms();
  const fileInputRef = useRef(null);
  const allLegalTerms = useMemo(() => {
    if (entityLegalTerms) {
      const existingIds = new Set(legalTerms.map(lt => lt.id));
      const uniqueEntityLegalTerms = entityLegalTerms.filter(entityLT => !existingIds.has(entityLT.id));
      return [...legalTerms, ...uniqueEntityLegalTerms];
    }
    return legalTerms;
  }, [entityLegalTerms, legalTerms]);
  const {
    createLegalTerms,
    isLoading: isCreatingLegalTerms
  } = useCreateLegalTerms({
    onSettled: newLegalTerms => {
      if (newLegalTerms) {
        onSelectLegalTerm(newLegalTerms);
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  });
  const handlePDFUpload = async e => {
    e.preventDefault();
    const file = e.target.files && e.target.files[0];
    createLegalTerms(file);
  };
  const isLoading = isLoadingLegalTerms || isCreatingLegalTerms;
  const selectedOption = useMemo(() => {
    return selectedLegalTermId ? allLegalTerms.find(legalTerm => legalTerm.id === selectedLegalTermId) : undefined;
  }, [selectedLegalTermId, allLegalTerms]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("input", {
      ref: fileInputRef,
      type: "file",
      accept: ".pdf",
      onChange: handlePDFUpload,
      "data-testid": LegalTermsDropdownTID.LegalTermDropdownFileInput(),
      hidden: true
    }), /*#__PURE__*/_jsx(EnhancedAutocomplete, {
      options: allLegalTerms,
      isLoading: isLoading,
      keyField: "id",
      labelField: "name",
      textFieldProps: {
        placeholder: 'Choose a document',
        label: 'Terms of Services'
      },
      selectedOption: selectedOption,
      applyOptionChange: option => {
        onSelectLegalTerm(option);
      },
      onAddItemClick: async () => {
        var _fileInputRef$current;
        (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 || _fileInputRef$current.click();
      },
      emptySearchText: "No matches found. Try again or create a new legal term.",
      addNewItemText: "Upload PDF",
      "data-testid": LegalTermsDropdownTID.LegalTermDropdown(),
      disabled: disabled
    })]
  });
};